import React from "react";

import { Icon, Icons } from "~/apps/shared/components/icon/icon";
import { AgencyNoticeType } from "~/apps/shared/constants/enums";

import { useLanguage } from "../../contexts/language.context";
import {
  AgencyNotice,
  AgencyNoticeModel,
} from "../../models/agency-notice.model";
import { styles } from "./agency-notice-header-banner.styles";
import { useAgencyNoticeHeaderBannerTranscription } from "./agency-notice-header-banner.transcription";
import { useAgencyNoticeHeaderBannerViewModel } from "./agency-notice-header-banner.view-model";

type Props = {
  agencyNotice: AgencyNotice;
  onClose: () => void;
  onDismiss: () => void;
};

const iconByAgencyNoticeType: Record<AgencyNoticeType, Icons> = {
  [AgencyNoticeType.CRITICAL]: "exclamation-triangle",
  [AgencyNoticeType.INFO]: "info-outline",
  [AgencyNoticeType.SUCCESS]: "check-circle",
  [AgencyNoticeType.WARNING]: "exclamation-triangle",
};

export const AgencyNoticeHeaderBanner: React.FC<Props> = (props) => {
  const { agencyNotice } = props;

  const {
    contentContainerRef,
    contentParagraphRef,
    close,
    dismiss,
    isExpanded,
    isSeeMoreButtonVisible,
    toggleIsExpanded,
  } = useAgencyNoticeHeaderBannerViewModel(props);

  const { transcription } = useAgencyNoticeHeaderBannerTranscription();

  const { languageCode } = useLanguage();

  const agencyNoticeModel = new AgencyNoticeModel(agencyNotice);

  return (
    <div css={styles.root({ agencyNotice })}>
      <Icon size={16} use={iconByAgencyNoticeType[agencyNotice.type]} />
      <div css={styles.content.root} ref={contentContainerRef}>
        <p css={styles.content.text({ isExpanded })} ref={contentParagraphRef}>
          {agencyNoticeModel.getFormattedContent(languageCode)}
          {!isExpanded && isSeeMoreButtonVisible ? "... " : ""}
        </p>
      </div>
      {isSeeMoreButtonVisible ? (
        <button css={styles.button} onClick={toggleIsExpanded}>
          {isExpanded ? transcription.seeLess : transcription.seeMore}
        </button>
      ) : null}
      {agencyNoticeModel.shouldShowDismissButton() ? (
        <button
          css={styles.dismiss}
          onClick={() => {
            if (agencyNoticeModel.isDismissImpossible()) {
              return;
            }

            if (agencyNoticeModel.isDismissNotPersistent()) {
              close();
            }
            if (agencyNoticeModel.isDismissPersistent()) {
              dismiss();
            }
          }}
        >
          <Icon size={16} use="x" />
        </button>
      ) : null}
    </div>
  );
};
